import * as React from 'react';
import * as style from './ModalFooter.styl';

export class ModalFooter extends React.Component {
  render() {
    return (
      <div className={style.global}>
        <div className="actionBar">{this.props.children}</div>
      </div>
    );
  }
}
